/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pos_Print_Stock_OutInputs */

const vi_pos_print_stock_out = /** @type {(inputs: Pos_Print_Stock_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In phiếu xuất kho`)
};

/**

* @param {Pos_Print_Stock_OutInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_print_stock_out = /** @type {((inputs?: Pos_Print_Stock_OutInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Print_Stock_OutInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_print_stock_out(inputs)
});